/**
 * @typedef TargetFilter
 * @property {string} type
 * @property {string} value
 */

/**
 * @param {object} audiencefilter
 * @param {string} audiencefilter.urn
 * @param {string} audiencefilter.value
 * @param {string} audiencefilter.type
 * @param {string} audiencefilter.expressionOperator
 * @param {string} [audiencefilter.logicalOperator]
 * @returns {TargetFilter}
 */
export const audienceTargetFilter = (audiencefilter: any) => {
  const { type } = audiencefilter
  return type === 'filter'
    ? {
        type,
        value: expression(
          audiencefilter.urn,
          audiencefilter.value,
          audiencefilter.expressionOperator,
          audiencefilter.logicalOperator,
          audiencefilter.attributeType
        )
      }
    : {
        type: 'filter',
        value: expression(
          'groups.display',
          audiencefilter.value,
          audiencefilter.expressionOperator,
          audiencefilter.logicalOperator,
          audiencefilter.attributeType
        )
      }
}

/**
 * Return a string scim expression
 *
 * @param {string} urn
 * @param {any} value
 * @param {string} operator
 * @param {string} selectedLogicalOperator
 * @param {string} attributeType
 * @returns {string}
 */
const expression = (urn: any, value: any, operator: any, selectedLogicalOperator: any, attributeType: any) => {
  let convertedValue

  if (attributeType === 'integer' || attributeType === 'decimal' || attributeType === 'boolean') {
    convertedValue = value
  } else {
    convertedValue = JSON.stringify(value)
  }

  let stringExpression = `${urn} ${operator} ${convertedValue}`

  const complexAttributeNames = ['groups', 'emails', 'phoneNumbers', 'photos', 'addresses']

  const scimSchema = 'urn:ietf:params:scim:schemas:extension:workgrid:2.0:'

  const isComplex = complexAttributeNames.some(complexName => {
    return urn.includes(complexName)
  })

  // Added to fix an LM bug for groups: https://forge.lmig.com/issues/browse/ETSWORK-8813
  if (operator === 'ne') {
    //If scim complex attributes change or if the custom attribute scim schema qualifier changes this will need to be updated
    if (urn.includes(scimSchema) || isComplex) {
      stringExpression = `not (${urn} eq ${JSON.stringify(value)})`
    } else {
      stringExpression = `${urn} ${operator} ${convertedValue}`
    }
  }

  if (selectedLogicalOperator) {
    return `${selectedLogicalOperator} ${stringExpression}`
  } else {
    return stringExpression
  }
}
